import React, { Component } from "react";
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import withWidth from '@material-ui/core/withWidth';
import { compose } from 'recompose';

const styles = theme => ({ 
    mainHeading: {
        position: 'relative',
        fontSize: '1.5em',
        marginBottom: 3,
        textTransform: 'capitalize'
      },
      titleIcon: {
        paddingTop: 5,
        fontWeight: 'bold',
      }
})

class ContentTitle extends Component {
  render() {
    const { classes, contentTitle, color, customProps } = this.props;
    return (
          <Grid item xs={12}>
            <h1 className={classes.mainHeading} style={{ marginTop: this.props.width === 'xs' ? 0 : 16 ,  color: color, padding: this.props.width === 'xs' ? 0 : '0px 10px'}}>
                {contentTitle}
            <Icon className={classes.titleIcon}>
                keyboard_arrow_right
            </Icon>
            </h1>
          </Grid> 
         
    );
  }
}

export default  compose(
    withWidth(),
    withStyles(styles))(ContentTitle);
